import type { DistributorItem } from "./distributor-find";
import { detectDistributorType } from "./distributor-type";
import SauerPartsDealerIconSrc from "./additional_icon_map_sauer-parts-dealer.png";
import OriginalPartsDealerIconSrc from "./additional_icon_map_original-parts-dealer.png";

/**
 * Render extra icons for a give distributor if it is tagged as Sauer Parts Dealer or Original Parts Dealer.
 */
export const renderAdditionalIconsForDistributor = (
  distributor: DistributorItem
) => {
  const distributorTags = getDistributorShopTags(distributor);

  if (distributorTags.length === 0) {
    return;
  }

  const wrappingElement = document.createElement("div");
  wrappingElement.classList.add("map__info__additional-icons");

  for (const tag of distributorTags) {
    const imageElement = document.createElement("img");
    imageElement.alt = tag;
    imageElement.src = SHOP_TAG_ICON_MAP[tag];

    wrappingElement.append(imageElement);
  }

  return wrappingElement;
};

// noinspection SpellCheckingInspection
const SHOP_TAG_ICON_MAP = {
  "Sauer Parts Dealer": SauerPartsDealerIconSrc,
  "Official Partsdealer": OriginalPartsDealerIconSrc,
} as const;

const getDistributorShopTags = (distributor: DistributorItem) => {
  if (detectDistributorType(distributor) !== "shop") {
    return [];
  }

  const tags = distributor.Workshop_Partsdealer_Type__c?.split(";");

  return tags.filter(
    (tag: string): tag is keyof typeof SHOP_TAG_ICON_MAP =>
      tag in SHOP_TAG_ICON_MAP
  );
};
